import React from 'react';

/**
 * Full-viewport spinner for the gaps where the app has nothing to show yet —
 * chiefly the auth handshake, which can run for several seconds when the
 * stored session has to be revalidated against Cognito.
 */
const FullPageSpinner = (props: { label?: string }) => {
  const { label = 'Loading' } = props;

  return (
    <div className="tw-col-span-12 tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-h-screen tw-gap-4">
      <span
        className="tw-h-16 tw-w-16 tw-inline-block tw-border-4 tw-border-primary-500 tw-border-t-transparent tw-rounded-full tw-animate-spin"
        role="status"
        aria-hidden="true"
      ></span>
      <p className="tw-text-neutral-500">{label}</p>
    </div>
  );
};

export default FullPageSpinner;
